var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.validatingToken)?_c('Loading'):_c('v-app',{class:_vm.deviceClass},[_c('Content'),(_vm.user)?_c('Header'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }